(function ($) {
    // Get Window Width and Height
    var windowWidth = $(window).outerWidth();
    var windowHeight = $(window).height();

    /* Document ready functions */
    $(document).ready(function () {
        new Swiper('.widescreen-section .swiper-container', {
            grabCursor: false,
            loop: true,
            speed: 1500,
            effect: 'fade',
            autoplay: {
                delay: 5000,
            },
        });

        new Swiper('.widescreens-section .swiper-container', {
            grabCursor: false,
            speed: 700,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
            },
        });
    });

    /* Resize functions */
    $(window).resize(function () {
        // Get Window Width and Height
        windowWidth = $(window).outerWidth();
        windowHeight = $(window).height();
    });
})(jQuery);
